<template>
  <div class="attendance-clock-record-list">
    <el-row class="table-search" type="flex" justify="space-between" align="middle">
      <el-col :xs="24" :md="24">
        <el-form
          size="medium"
          :inline="true"
          :model="searchCondition"
          class="demo-form-inline"
        >
          <el-form-item label="任务名称">
            <el-input
              v-model="searchCondition.mission_name"
              placeholder="请输入任务名称"
              clearable
              style="width: 200px;"
            />
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              v-model="searchCondition.task_status"
              placeholder="全部"
              clearable
              style="width: 120px;"
            >
              <el-option label="全部" value="" />
              <el-option label="进行中" :value="1" />
              <el-option label="已结束" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchButton">查询</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-download"
              :loading="exportLoading"
              @click="handleExport"
            >
              导出
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <ApeTable
      ref="apeTable"
      :data="tableList"
      :columns="columns"
      :loading="loadingStatus"
      :pagingData="pagingData"
      @switchPaging="switchPaging"
      highlight-current-row
    >
      <template slot="first-column">
        <el-table-column type="selection" align="center" />
      </template>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <el-tag
            :type="computeTaskStatus(scope.row) === 1 ? 'success' : 'info'"
            size="small"
          >
            {{ computeTaskStatusText(scope.row) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="goStats(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </ApeTable>
  </div>
</template>

<script>
import ApeTable from "@/components/ApeTable";

const PAGE_STATE_KEY = "attendance_clock_record_list_state";
const REFRESH_FLAG_KEY = "attendance_clock_record_refresh_record_list";
const DEFAULT_SEARCH_CONDITION = {
  mission_name: "",
  task_status: "",
};
const DEFAULT_PAGING_INFO = {
  current_page: 1,
  page_size: 10,
};
const DEFAULT_PAGING_DATA = {
  is_show: true,
  layout: "total, sizes, prev, pager, next, jumper",
  total: 0,
  offset: 0,
};
const TABLE_COLUMNS = [
  {
    title: "任务名称",
    value: "mission_name",
    header_align: "center",
    align: "center",
  },
  {
    title: "打卡开始日期",
    value: "check_start_date",
    header_align: "center",
    align: "center",
  },
  {
    title: "打卡结束日期",
    value: "check_end_date",
    header_align: "center",
    align: "center",
  },
  {
    title: "打卡人数",
    value: "check_in_user_count",
    header_align: "center",
    align: "center",
  },
  {
    title: "打卡地点",
    value: "location_name",
    header_align: "center",
    align: "center",
  },
  {
    title: "打卡方式",
    value: "check_method_text",
    header_align: "center",
    align: "center",
  },
];

export default {
  name: "AttendanceClockRecordList",
  components: {
    ApeTable,
  },
  data() {
    return {
      loadingStatus: false,
      exportLoading: false,
      searchCondition: this.getDefaultSearchCondition(),
      columns: TABLE_COLUMNS,
      tableList: [],
      pagingData: this.getDefaultPagingData(),
    };
  },
  mounted() {
    if (!this.restorePageState()) {
      this.init();
      return;
    }
    this.$nextTick(() => {
      if (this.consumeRefreshFlag()) {
        this.init();
      }
    });
  },
  beforeDestroy() {
    this.savePageState();
  },
  methods: {
    consumeRefreshFlag() {
      const flag = window.sessionStorage.getItem(REFRESH_FLAG_KEY);
      if (flag === "1") {
        window.sessionStorage.removeItem(REFRESH_FLAG_KEY);
        return true;
      }
      return false;
    },
    getDefaultSearchCondition() {
      return { ...DEFAULT_SEARCH_CONDITION };
    },
    getDefaultPagingData() {
      return { ...DEFAULT_PAGING_DATA };
    },
    getDefaultPagingInfo() {
      return { ...DEFAULT_PAGING_INFO };
    },
    getPagingInfo(type) {
      if (!this.$refs.apeTable) {
        return this.getDefaultPagingInfo();
      }
      return this.$refs.apeTable.getPagingInfo(type);
    },
    savePageState() {
      const pagingInfo = this.$refs.apeTable
        ? this.getPagingInfo()
        : {
            ...this.getDefaultPagingInfo(),
            page_size: this.pagingData.page_size || DEFAULT_PAGING_INFO.page_size,
          };
      window.sessionStorage.setItem(
        PAGE_STATE_KEY,
        JSON.stringify({
          searchCondition: this.searchCondition,
          tableList: this.tableList,
          pagingData: this.pagingData,
          pagingInfo,
        }),
      );
    },
    restorePageState() {
      const raw = window.sessionStorage.getItem(PAGE_STATE_KEY);
      if (!raw) return false;
      try {
        const state = JSON.parse(raw);
        this.searchCondition = state.searchCondition || this.getDefaultSearchCondition();
        this.tableList = Array.isArray(state.tableList) ? state.tableList : [];
        this.pagingData = state.pagingData || this.getDefaultPagingData();
        this.$nextTick(() => {
          if (this.$refs.apeTable && state.pagingInfo) {
            this.$refs.apeTable.apePageSize = state.pagingInfo.page_size || 0;
            this.$refs.apeTable.setCurrentChange(state.pagingInfo.current_page || 1);
          }
        });
        return true;
      } catch (e) {
        window.sessionStorage.removeItem(PAGE_STATE_KEY);
        return false;
      }
    },
    parseYmd(str) {
      if (!str) return null;
      const p = String(str).trim().split("-");
      if (p.length < 3) return null;
      const y = parseInt(p[0], 10);
      const m = parseInt(p[1], 10);
      const d = parseInt(p[2], 10);
      if (Number.isNaN(y) || Number.isNaN(m) || Number.isNaN(d)) return null;
      return new Date(y, m - 1, d);
    },
    todayDate() {
      const t = new Date();
      return new Date(t.getFullYear(), t.getMonth(), t.getDate());
    },
    computeTaskStatus(row) {
      if (row.task_status != null) return Number(row.task_status) === 2 ? 2 : 1;
      if (row.status != null) return Number(row.status) === 2 ? 2 : 1;
      const s = this.parseYmd(row.check_start_date);
      const e = this.parseYmd(row.check_end_date);
      if (!s || !e) return 1;
      const today = this.todayDate();
      if (today >= s && today <= e) return 1;
      return 2;
    },
    computeTaskStatusText(row) {
      if (row.task_status_text) return row.task_status_text;
      if (row.status_text) return row.status_text;
      return this.computeTaskStatus(row) === 1 ? "进行中" : "已结束";
    },
    goStats(row) {
      const q = {
        mission_id: row.mission_id != null ? String(row.mission_id) : "",
        mission_name: row.mission_name != null ? String(row.mission_name) : "",
      };
      this.$router.push({ path: "/attendanceClockStats", query: q });
    },
    searchButton() {
      this.init("search");
    },
    resetSearch() {
      this.searchCondition = this.getDefaultSearchCondition();
      this.init("search");
    },
    switchPaging() {
      this.init();
    },
    buildListParams(pagingInfo) {
      const p = {
        current_page: pagingInfo.current_page,
        page_size: pagingInfo.page_size,
      };
      if (this.searchCondition.mission_name) {
        p.mission_name = this.searchCondition.mission_name.trim();
      }
      if (this.searchCondition.task_status !== "" && this.searchCondition.task_status != null) {
        p.task_status = this.searchCondition.task_status;
      }
      return p;
    },
    buildExportParams() {
      const p = {};
      if (this.searchCondition.mission_name) {
        p.mission_name = this.searchCondition.mission_name.trim();
      }
      if (this.searchCondition.task_status !== "" && this.searchCondition.task_status != null) {
        p.task_status = this.searchCondition.task_status;
      }
      return p;
    },
    refreshByTabSwitch() {
      this.init();
    },
    async init(type) {
      if (type && this.mxResetPage) {
        this.mxResetPage();
      }
      this.loadingStatus = true;
      try {
        const pagingInfo = this.getPagingInfo(type);
        if (type === "search") {
          pagingInfo.current_page = 1;
        }
        const params = this.buildListParams(pagingInfo);
        const res = await this.$api.checkInTaskList(params);
        const list = (res && res.list) || [];
        this.tableList = list;
        const pages = (res && res.pages) || {};
        this.pagingData.total = pages.total || 0;
        this.pagingData.page_size = pagingInfo.page_size;
        this.pagingData.offset =
          pages.offset != null ? pages.offset : (pagingInfo.current_page - 1) * pagingInfo.page_size;
        this.savePageState();
      } catch (_) {
        void _;
        this.tableList = [];
      } finally {
        this.loadingStatus = false;
      }
    },
    async handleExport() {
      this.exportLoading = true;
      try {
        const data = await this.$api.checkInTaskExport(this.buildExportParams());
        const d = data && typeof data === "object" ? data : {};
        const header = d.header;
        const rows = d.rows;
        if (!header || !rows || !rows.length) {
          this.$message.warning("暂无数据可导出");
          return;
        }
        const { export_json_to_excel } = await import("@/excel/Export2Excel");
        const suffix = this.searchCondition.month || new Date().toISOString().slice(0, 7);
        export_json_to_excel({
          header,
          data: rows,
          filename: `任务打卡_${suffix}`,
          autoWidth: true,
          bookType: "xlsx",
        });
        this.$message.success("导出成功");
      } catch (_) {
        void _;
      } finally {
        this.exportLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table-search {
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.search-right {
  text-align: right;

  @media (max-width: 992px) {
    text-align: left;
    margin-top: 8px;
  }
}
</style>
